// Model.js
// -----------------------
// @module Case
define("MHI.AddressCustomization.SaveAddress.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/SaveAddress/SuiteScript2/SaveAddress.Service.ss"
            ),
            true
        )
});
});
